import Swal from "sweetalert2";

export const mostrarCargandoPDF = async (
  mensaje = "Generando PDF, por favor espere...",
  titulo = "Procesando documento"
) => {
  Swal.fire({
    title: titulo,
    text: mensaje,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });

  await new Promise((resolve) => setTimeout(resolve, 150));
};

export const cerrarCargandoPDF = () => {
  if (Swal.isVisible() && Swal.isLoading()) {
    Swal.close();
  }
};

export const ejecutarConCargandoPDF = async (
  asyncFn,
  mensaje = "Generando PDF, por favor espere...",
  titulo = "Procesando documento"
) => {
  const mostrandoLoaderPrevio = Swal.isVisible() && Swal.isLoading();
  if (!mostrandoLoaderPrevio) {
    await mostrarCargandoPDF(mensaje, titulo);
  }

  try {
    const resultado = await asyncFn();
    return resultado;
  } catch (error) {
    console.error("Error durante la generación del PDF/Reporte:", error);
    Swal.fire({
      icon: "error",
      title: "Error al generar reporte",
      text: "Ocurrió un problema al procesar el documento. Intente de nuevo.",
      confirmButtonColor: "#006787",
    });
    throw error;
  } finally {
    if (!mostrandoLoaderPrevio && Swal.isVisible() && Swal.isLoading()) {
      Swal.close();
    }
  }
};
